















































































































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import ModalAddKamar from "@/components/modal/ModalAddKamar.vue";
import ModalAddPasien from "@/components/modal/ModalAddPasien.vue";
import ModalEditDiagnosa from "@/components/modal/ModalEditDiagnosa.vue";
import ModalMutasiPasien from "@/components/modal/ModalMutasiPasien.vue";
import ModalBatalMondok from "@/components/modal/ModalBatalMondok.vue";
import { userModule } from "@/store/modules/user";
import UnitAutoComplete from "@/components/UnitAutoComplete.vue";
import { storeBed } from "@/store/modules/bed";
import { storeReferensi } from "@/store/modules/referensi";
import { appModule } from "@/store/modules/app";
import ModalKonfirmasi from "@/components/modal/ModalKonfirmasi.vue";
import ModalEditKamar from "@/components/modal/ModalEditKamar.vue";
import ModalBooking from "@/components/modal/ModalBooking.vue";
import ModalListBooking from "@/components/modal/ModalListBooking.vue";
import ModalListBookingByRM from "@/components/modal/ModalListBookingByRM.vue";
import DataBed from "@/services/DataBed";
import moment from "moment";

@Component({
  components: {
    UnitAutoComplete,
    ModalAddKamar,
    ModalAddPasien,
    ModalMutasiPasien,
    ModalEditDiagnosa,
    ModalKonfirmasi,
    ModalEditKamar,
    ModalBooking,
    ModalListBooking,
    ModalBatalMondok,
    ModalListBookingByRM
  }
})
export default class InfoAdmin extends Vue {
  dtBed = {};
  modalAddKamar = false;
  modalAddPasien = false;
  modalMutasiPasien = false;
  modalEditDiagnosa = false;
  modalBatalMondok = false;
  itemRow = {};
  modalOpenKonfirmasi = false;
  modalKonfirmasiBed = false;
  modalEditKamar = false;
  modalBooking = false;
  modalListBooking = false;
  modalListBookingByRM = false;
  msgConfirm = "";
  timer: number;
  rusak = 0;
  Kosong = 0;
  isi = 0;
  maintenance = 0;
  listBed = [];

  get headers() {
    const head = [
      {
        text: "NOMOR KAMAR/TT",
        value: "kamar",
        width: "10vh",
        align: "center"
      },
      {
        text: "KELAS",
        value: "kelas.nama",
        width: "10vh",
        align: "center"
      },
      {
        text: "STATUS",
        value: "status",
        width: "20vh",
        align: "center"
      },
      {
        text: "DATA PASIEN",
        value: "pasien",
        align: "left"
      },
      {
        text: "DIAGNOSA MASUK",
        value: "diagnosa",
        align: "left",
        width: "25vh"
      },
      {
        text: "CATATAN PASIEN",
        value: "catatan",
        align: "left",
        width: "20vh"
      },
      {
        text: "AKSI",
        value: "aksi",
        align: "center"
      }
    ];
    return head;
  }

  // unit = { id: "50", nama: "WISNU (ICU COVID)" };
  unit = {};
  disUnit = false;
  // listBed = [];

  mounted() {
    this.disUnit = false;
    // this.getBed();
    // this.timer = setInterval(this.getBed, 600000);
  }

  @Watch("akses")
  valAkses(val) {
    if (val["unit_id"] == "*") {
      console.log("semua");
      this.unit = { id: "50", nama: "WISNU (ICU COVID)" };
      this.disUnit = false;
      this.getBed();
    } else {
      this.unit = { id: this.akses["unit_id"] };
      // this.disUnit = true;
      console.log("unit tertentu");
      this.getBed();
    }
  }

  get listBedAll() {
    return storeBed.bed;
  }

  get dataBooking() {
    return storeBed.bookingUnit;
  }

  get listStatus() {
    return storeReferensi.status;
  }

  get akses() {
    return storeBed.akses;
  }

  get user() {
    return userModule.user;
  }

  get loading() {
    return storeBed.loading;
  }

  setUnit(val) {
    this.unit = val;
  }

  getBed() {
    // console.log("getbed");
    storeBed.actBedByUnit(this.unit["id"]);
    storeBed.actBookingUnit(this.unit["id"]);
  }

  selectRowPasien(item, row) {
    console.log(item);
    this.itemRow = item;
    storeReferensi.actTempStatus(item);

    const param = {
      unitID: item["unit"].id,
      kelasID: item["kelas"].id
    };
    storeBed.actBooking(param);
    // if (item.status.id == "1") {
    //   this.itemRow = item;
    //   this.modalMutasiPasien = true;
    // } else if (item.status.id == "2") {
    //   this.modalAddPasien = true;
    //   this.itemRow = item;
    // }
  }

  mutasi() {
    this.modalMutasiPasien = true;
  }

  editDiagnosa() {
    this.modalEditDiagnosa = true;
  }
  batalMondok() {
    this.modalBatalMondok = true;
  }

  pasienIn() {
    this.modalAddPasien = true;
  }

  pasienOut(val) {
    this.msgConfirm =
      "Anda yakin akan memulangkan pasien a/n " + val.pasien.nama;
    this.modalOpenKonfirmasi = true;
  }
  pulang() {
    const dt = DataBed.pulangPasien(
      this.itemRow["pasien"].rm,
      this.user["pegawai_id"]
    );
    dt.then(dt => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        appModule.NoticeDelay("Berhasil memulangkan Pasien");
        storeBed.actBedByUnit(this.unit["id"]);
      }
    });
  }

  editBed() {
    this.modalEditKamar = true;
  }

  deleteBed(val) {
    console.log(val);
    this.msgConfirm =
      "Anda yakin akan Menghapus Kamar " +
      val.kamar +
      " (" +
      val.kelas.nama +
      ")";
    this.modalKonfirmasiBed = true;
  }

  hapusBed() {
    const dt = DataBed.deleteBed(this.itemRow["id"], this.user["pegawai_id"]);
    dt.then(dt => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        appModule.NoticeDelay("Berhasil menghapus Bed/Kamar");
        storeBed.actBedByUnit(this.unit["id"]);
      }
    });
  }

  addBed() {
    this.modalAddKamar = true;
  }
  booking() {
    this.modalBooking = true;
  }
  listBooking() {
    this.modalListBooking = true;
  }
  searchBooking() {
    this.modalListBookingByRM = true;
  }

  @Watch("unit")
  watchUnit(val) {
    this.unit = val;
    storeBed.actBedByUnit(val.id);
    storeBed.actBookingUnit(val.id);
  }
  @Watch("listBedAll")
  watchListBed(val) {
    this.isi = val.filter(
      val => val.status.id == 1 && val.gabung == "0"
    ).length;
    this.Kosong = val.filter(
      val => val.status.id == 2 && val.gabung == "0"
    ).length;
    this.rusak = val.filter(
      val => val.status.id == 4 && val.gabung == "0"
    ).length;
    this.maintenance = val.filter(
      val => val.status.id == 3 && val.gabung == "0"
    ).length;
    this.listBed = this.listBedAll;
  }

  ttIsi() {
    this.listBed = this.listBedAll.filter(val => val.status.id == 1);
  }
  ttKosong() {
    this.listBed = this.listBedAll.filter(val => val.status.id == 2);
  }
  ttRusak() {
    this.listBed = this.listBedAll.filter(val => val.status.id == 4);
  }
  ttMaintenance() {
    this.listBed = this.listBedAll.filter(val => val.status.id == 3);
  }
  test() {
    // appModule.sendErrorAlert("aaa");
    // appModule.NoticeDelay("Berhasil Menambahkan Kamar");
    appModule.NoticeDelayAlert("eror");
  }
  getFormatDateTime(date) {
    return date
      ? moment(date, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm:ss")
      : "";
  }
  allPasien() {
    const routeData = this.$router.resolve({ path: "/informasi" });
    window.open(routeData.href, "_blank");
  }
}
